<div class="banner d-lg-flex d-none">
  <h1>{{ 'badge.page.title' | translate }}</h1>
</div>

<!--Scorecard carousel-->
<!-- <fgbcl-scorecard-carousel [icon]="'chevron_right'" [showAllView]="false" [phaseThree]="true"></fgbcl-scorecard-carousel> -->

<div class="container">
  <!-- <fgbcl-badge-overview-list [phaseThree]="true" [showPlaceholder]="true"></fgbcl-badge-overview-list> -->
</div>
